import { render, staticRenderFns } from "./ClientReferalDesk.vue?vue&type=template&id=dc5633b6"
import script from "./ClientReferalDesk.vue?vue&type=script&lang=js"
export * from "./ClientReferalDesk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports